import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
// import { useHistory } from "react-router";
// APIモジュール
import API from "@aws-amplify/api";
import * as mutations from "../graphql/mutations";

// フォームコンポーネント
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  TextField,
  Typography,
  Table,
  TableBody,
  TableContainer,
  Button,
  Container,
  Paper,
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";

import { StyledTableCell, StyledTableRow } from "../modules/modules";
import { makeStyles } from "@material-ui/core/styles";

import BuymaLicense from "../component/BuymaLicense";
import ShopLicense from "../component/ShopLicense";
import License from "../component/License";
import SearchData from "../component/SearchData";

const columns = [
  { id: "name", name: "名前", type: "text" },
  { id: "phone", name: "電話番号", type: "text" },
  { id: "address", name: "住所", type: "text" },
];

const useStyles = makeStyles((theme) => ({
  field: {
    width: "100%",
    marginTop: theme.spacing(3),
  },
  button: {
    width: "100%",
    marginTop: theme.spacing(3),
  },
  interval: {
    marginTop: theme.spacing(5),
  },
  paper: {
    alignItems: "center",
    marginTop: theme.spacing(5),
    margin: theme.spacing(3),
    padding: theme.spacing(8),
  },
}));

export default function Profile(props) {
  const classes = useStyles();
  // const history = useHistory();
  const userInfo = props.userInfo;
  const profile = props.profile;
  const [open, setOpen] = useState(false);
  // const [msg, setMsg] = useState();

  const formik = useFormik({
    initialValues: {
      name: "",
      phone: "",
      address: "",
    },
    onSubmit: (values) => {
      handleUpdate(values);
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required("名前は必須項目です。").nullable(),
      // phone: Yup.string().matches(
      //   /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
      //   "電話番号が正しくありません"
      // ),
    }),
  });

  useEffect(() => {
    if (profile.name) {
      formik.setFieldValue("name", profile.name);
      formik.setFieldValue("phone", profile.phone);
      formik.setFieldValue("address", profile.address);
    }
  }, [profile]);

  // Graphqlレコード更新処理
  const handleUpdate = (input) => {
    input["id"] = userInfo.id;
    console.log(input);

    API.graphql({ query: mutations.updateProfile, variables: { input: input } })
      .then((res) => {
        // setMsg();
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <React.Fragment>
      {profile.name ? (
        <Container className={classes.interval}>
          <Alert variant="outlined" severity="info">
            プロフィールの登録ありがとうございます。
            <br />
            次のステップで、システムをダウンロードして使う方は、
            <Link color="textSecondary" to="/download">
              こちら
            </Link>
            からダウンロードしてください。
          </Alert>
          <Button variant="contained" fullWidth onClick={() => setOpen(!open)}>
            プロフィールを編集
          </Button>
        </Container>
      ) : (
        <Alert variant="filled" severity="error">
          ホームへアクセスするにはプロフィールのご登録をお願いします。
        </Alert>
      )}

      {!profile.name || open ? (
        <Paper className={classes.paper} variant="outlined">
          <Alert variant="outlined" severity="error">
            下のフォームにある「名前」は必須項目です。
          </Alert>
          <Container className={classes.interval}>
            <Typography variant="h4" align="center" gutterBottom>
              プロフィールを登録
            </Typography>
            <form onSubmit={formik.handleSubmit}>
              {columns.map((column) => (
                <div key={column["id"]}>
                  <TextField
                    label={column["name"]}
                    type={column["type"]}
                    className={classes.field}
                    {...formik.getFieldProps(column["id"])}
                  />
                  {formik.touched[column["id"]] &&
                  formik.errors[column["id"]] ? (
                    <Typography variant="caption" color="error">
                      {formik.errors[column["id"]]}
                    </Typography>
                  ) : null}
                </div>
              ))}
            </form>
            <form onSubmit={formik.handleSubmit}>
              <Button
                className={classes.button}
                variant="contained"
                type="submit"
                disabled={!formik.isValid}
              >
                登録
              </Button>
              {/* {msg} */}
            </form>
          </Container>
        </Paper>
      ) : null}

      <Container className={classes.interval}>
        <TableContainer>
          <Typography variant="h4" align="center" gutterBottom>
            プロフィール
          </Typography>
          <Table className={classes.table} stickyHeader>
            <TableBody>
              <StyledTableRow>
                <StyledTableCell className={classes.table_head} variant="head">
                  ステータス
                </StyledTableCell>
                <StyledTableCell>
                  {userInfo.trial ? (
                    <Typography>トライアル期間中です</Typography>
                  ) : (
                    <Typography>トライアル期間は終了しています</Typography>
                  )}
                </StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell className={classes.table_head} variant="head">
                  名前
                </StyledTableCell>
                <StyledTableCell>{profile.name}</StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell className={classes.table_head} variant="head">
                  電話番号
                </StyledTableCell>
                <StyledTableCell>{profile.phone}</StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell className={classes.table_head} variant="head">
                  住所
                </StyledTableCell>
                <StyledTableCell>{profile.address}</StyledTableCell>
              </StyledTableRow>
              {userInfo.stripeParentAccount ? (
                <StyledTableRow>
                  <StyledTableCell
                    className={classes.table_head}
                    variant="head"
                  >
                    紹介者様ID
                  </StyledTableCell>
                  <StyledTableCell>
                    {userInfo.stripeParentAccount}
                  </StyledTableCell>
                </StyledTableRow>
              ) : null}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>

      <Container className={classes.interval}>
        <BuymaLicense {...props} />
      </Container>

      <Container className={classes.interval}>
        <ShopLicense {...props} />
      </Container>

      <Container className={classes.interval}>
        <License {...props} />
      </Container>

      <SearchData {...props} />
    </React.Fragment>
  );
}
